import { createAsyncThunk } from "@reduxjs/toolkit";
import { RESETPASSWORD_API_URL, SET_INITIAL_PASSWORD_API_URL } from "@custom/constant";
import { ResetPasswordFormTypes } from "../../Auth/helper/auth";

type ResetPasswordRequest = ResetPasswordFormTypes & { initialPasswordChange?: boolean };

const resetPasswordApi = createAsyncThunk('auth/resetPassword', async (resetPasswordData: ResetPasswordRequest, { rejectWithValue }) => {
    const { initialPasswordChange, ...body } = resetPasswordData;
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    try {
        const response = await fetch(initialPasswordChange ? SET_INITIAL_PASSWORD_API_URL : RESETPASSWORD_API_URL, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...(initialPasswordChange && token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(body),
        });
        const data = await response.json();
        // The API replies 200 with `status: 'ERROR'` for business failures, so both cases are rejected here
        if (!response.ok || data?.status === 'ERROR') {
            return rejectWithValue(data);
        }
        return data;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export default resetPasswordApi;
